import React from "react";
import { BookOpenIcon, CalendarDaysIcon, FileTextIcon, HeadphonesIcon, ListChecksIcon, MapIcon, MoonIcon, NotebookPenIcon, PlayCircleIcon, SendIcon, SparklesIcon, WindIcon, BoxIcon } from "lucide-react";
import { bonuses } from "../data/landing";
import { BonusFormat } from "../types/landing";
const formatIcons: Record<BonusFormat, BoxIcon> = {
  Audio: HeadphonesIcon,
  Checklist: ListChecksIcon,
  Guía: BookOpenIcon,
  PDF: FileTextIcon,
  Masterclass: PlayCircleIcon,
  Planner: CalendarDaysIcon,
  Meditación: SparklesIcon,
  Ebook: BookOpenIcon,
  Template: NotebookPenIcon,
  Ritual: MoonIcon,
  Técnica: WindIcon,
  Comunidad: SendIcon,
  "Sesión grabada": BoxIcon,
  "Mapa digital": MapIcon
};
export function BonusSection() {
  return <section id="bonus" className="scroll-mt-20 border-b border-line" data-id="element-22" data-mp="1eorb4il5s93u">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28" data-id="element-23" data-mp="qzeu4wjlawqz">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-24" data-mp="mz4lfc4exs8f">
          <h2 className="max-w-2xl font-serif text-4xl leading-tight text-cream md:text-5xl" data-id="element-25" data-mp="29s323dgjznan">
            Además del ebook, 5 bonus digitales de regalo
          </h2>
          <p className="text-muted md:text-right" data-id="element-26" data-mp="2epl9v0iu3wh2">Todo incluido en el paquete completo</p>
        </div>

        <ul className="mt-12 max-w-3xl border-b border-line" data-id="element-27" data-mp="2jio83lyk3u3l">
          {bonuses.map(bonus => {
          const Icon = formatIcons[bonus.format];
          return <li key={bonus.title} className="flex gap-5 border-t border-line py-6" data-id="element-28" data-mp="1qtquvx97cnhp">
                <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-emerald-deep text-gold" data-id="element-29" data-mp="1vs1z9sgqa5sj">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-30" data-mp="20qd8q2342ea8" />
                </span>
                <div data-id="element-31" data-mp="25qrjhrw3k2by">
                  <p className="text-xs font-medium text-gold" data-id="element-32" data-mp="25r9gwruhwmlg">{bonus.format}</p>
                  <h3 className="mt-1 font-medium text-cream" data-id="element-33" data-mp="3c5ifbh6d4wz4">{bonus.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-34" data-mp="3h554mozgu3oa">{bonus.description}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}